export const OnlyDateConverter = (data) => {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var ISTTime = new Date(Number(data));
  var year = ISTTime.getFullYear().toString();
  var month = months[ISTTime.getMonth()];
  var date = String(ISTTime.getDate() + 0).padStart(2, "0");
  var fullTimes = date + " " + month + " " + year;
  return fullTimes;
};
 
export const OnlyTimeConverter = (data) => {
  var ISTTime = new Date(Number(data));
  var time = ISTTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  var fullTimes = time;
  return fullTimes;
};
 
export const OnlyDateTimeConverter = (data) => {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var ISTTime = new Date(Number(data));
  var time = ISTTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  var year = ISTTime.getFullYear().toString();
  var month = months[ISTTime.getMonth()];
  var date = String(ISTTime.getDate() + 0).padStart(2, "0");
  var fullTimes = date + " " + month + " " + year + "-" + time;
  return fullTimes;
};
 
export const FormatDay = (data) => {
  const date = new Date(data);
  return date.toLocaleDateString("en-GB", { weekday: "long" });

};
export const FormatDate = (data) => {
  const date = new Date(data);
  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
 
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  const fullFormattedDate = `${formattedDate} - ${formattedTime}`;
  return fullFormattedDate;
};
 
export const FormatDateMonth = (timestamp) => {
  if (!timestamp) {
    return "--"
  }
  var a = new Date(timestamp);
  var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var monthName = monthNames[a.getMonth()];
  let date = a.getDate();
  var formattedDate = date + " " + monthName;
  return formattedDate;
};

export const DisablePastDate = () => {
  const today = new Date();
  const dd = String(today.getDate() + 0).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  return dd + "-" + mm + "-" + yyyy;
};

export const convertTimestampToTime = (timestamp) => {
  const date = new Date(timestamp);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${hours}:${minutes}:${seconds}`;
}

export const formatDateToISO = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
}
export const NewsDateConverter = (data) => {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var ISTTime = new Date(Number(data));
  var year = ISTTime.getFullYear().toString();
  var month = months[ISTTime.getMonth()];
  var date = String(ISTTime.getDate() + 0).padStart(2, "0");
  var fullTimes = month + " " + date +","+ year ;
  return fullTimes;
};

export function formatTimeRange(startTimeStr, hoursToAdd) {
  const [startHour, startMinute] = String(startTimeStr).split(":").map(Number);

  const startDate = new Date();
  startDate.setHours(startHour);
  startDate.setMinutes(startMinute);

  const endDate = new Date(startDate);
  endDate.setHours(endDate.getHours() + hoursToAdd);

  const formatAMPM = (date) => {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert 0 or 13+ to 12-hour format
    minutes = String(minutes).padStart(2, "0");

    return `${hours}:${minutes} ${ampm}`;
  };

  const startFormatted = formatAMPM(startDate);
  const endFormatted = formatAMPM(endDate);

  return `${startFormatted} - ${endFormatted}`;
}

export function convertTo12Hour(time24) {
  const [hour, minute] = String(time24).split(":");

  let hours = parseInt(hour, 10);
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 becomes 12

  return `${hours}:${minute} ${ampm}`;
}